import { Stack } from "@mui/material";
import TableView from "../TableView";
import { useFormContext } from "react-hook-form";

export default function InfoStepAprovacao() {

    const { watch } = useFormContext()
    const selectedOption = watch('step_aprovacao.option') === 'criar_titulo' ?
        "Prosseguir com a criação do título" :
        "Abrir solicitação de criação de título a pagar";

    return (
        <>
            <Stack gap={1}>
                <TableView
                    title=""
                    text={selectedOption}
                />
            </Stack>
        </>
    )
}